import {Task} from '@megaphonenpm/mputils/src/Task.js';


export class StartRankingsDataManagerTask extends Task {
  constructor (rankingsDataManager) {
    super();

    this.name = 'START_RANKINGS_DATAMANAGER';
    this.rankingsDataManager = rankingsDataManager;
  }

  start () {
    super.start();

    this.rankingsDataManager.start();

    this.done();
  }
}
